
import { Routes, Route, Navigate } from 'react-router-dom';
import { PrivateRoute } from './commonRoute';
import PageNotFound from '../pages/PageNotFound/PageNotFound';
import RegulatorHome from '../modules/Regulator/Home/Home';
import RegulatorAlerts from '../modules/Regulator/Alerts/Alerts';
import NewsLayout from '../shared/News/NewsLayout';
import ExternalLinks from '../shared/ExternalLinks/ExternalLinks';
import NewsCategory from '../shared/NewsCategory/NewsCategory';
import NewsDetails from '../shared/News/NewsDetails';
import Help from '../pages/Help/Help';
import Profile from '../shared/Profile/Profile';
import Reports from '../shared/Reports/Reports';
import ReportDetail from '../shared/Reports/ReportDetail';
import NewsAndUpdates from '../modules/Analyst/NewsAndUpdates/NewsAndUpdates';
import PreviewReport from '../modules/Analyst/Reports/PreviewReport/PreviewReport';
import DownloadReport from '../modules/Analyst/Reports/DownloadReport/DownloadReport';
import Sports from '../shared/Sports/Sports';
import { useMemo } from 'react';
import { getValidRouteName } from '../utils/reuse';
import RegulatorMessages from '../modules/Regulator/Messages/Messages';

const GoverningBodyRoutes = () => {
    const routeName = useMemo(() => {
      const lastVisitedPath = localStorage.getItem("lastVisitedPath");
      const routePaths = ['/home', '/alerts', '/news', '/external-links', '/news-category', '/news-details', '/help', '/profile-details', '/sports', '/reports', '/report-detail', '/news', '/preview-report', '/download-report'];
      if (lastVisitedPath) {
        const getPathName = getValidRouteName(lastVisitedPath);
        const pathname = new URL(getPathName, window.location.origin).pathname;
        const basePath = pathname.split('/').slice(0, 2).join('/');
        if (routePaths.includes(basePath)) {
            localStorage.removeItem("lastVisitedPath");
            return getPathName;
        }
    }
      return '/home';
  }, []);
    return <Routes>
        <Route element={<PrivateRoute />} >
          <Route path='/' element={<Navigate to='/login' />} />
          <Route path='/login' element={ <Navigate to={`${routeName}`} /> } />
          <Route path='/otp' element={ <Navigate to={`${routeName}`} /> } />
          <Route path='/home' element={ <RegulatorHome /> } />
          <Route path='/alerts' element={ <RegulatorAlerts />} />
          <Route path='/news' element={ <NewsLayout /> } />
          <Route path='/external-links' element={ <ExternalLinks /> } />
          <Route path='/conversations' element={ <RegulatorMessages /> } />
          <Route path="/news-category" element={ <NewsCategory /> } />
          <Route path="/news-details" element={ <NewsDetails /> } />
          <Route path='/help' element={ <Help /> } />
          <Route path='/profile-details' element={ <Profile /> } />
          <Route path='/sports' element={<Sports />} />
          <Route path='/reports' element={ <Reports /> } />
          <Route path='/report-detail' element={ <ReportDetail /> } />
          <Route path='/news' element={ <NewsAndUpdates /> } />
          <Route path='/preview-report' element={ <PreviewReport /> } />
          <Route path='/download-report' element={ <DownloadReport /> } />
          <Route path='/page-not-found' element={<PageNotFound />} />
          <Route path='*' element={<Navigate to='/page-not-found' />} />
        </Route>
    </Routes>


}
export default GoverningBodyRoutes